import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_SUPPORTER_PETITION_TABS_UPDATE_COUNT = createFcmConfig('supporter_petition_tabs_update_count', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
